import React from 'react'
import styled from '@emotion/styled'
import { Button, ButtonProps } from '@mui/material'

const StyledRoundedBtn = styled(Button)({
  borderRadius: '24px'
})

const StyledSquaredBtn = styled(Button)({
  borderRadius: '16px'
})

export const RoundedButton = (props: ButtonProps) => {
  const { children, ...otherProps } = props
  return <StyledRoundedBtn {...otherProps}>{children}</StyledRoundedBtn>
}

export const SquaredButton = (props: ButtonProps) => {
  const { children, ...otherProps } = props

  return <StyledSquaredBtn {...otherProps}>{children}</StyledSquaredBtn>
}
